import { SEVERITIES_INFO } from '../../../../consts/Severity';
import { INCIDENT_STATUS, INCIDENT_TYPE } from '@silverfort-nodelibs/common/utils/consts';
import { RISK_SEVERITY } from '@silverfort-nodelibs/common/utils/insight';

export type IncidentStatus = {
    value: number;
    title: string;
    color: string;
    textColor: string;
};

const INCIDENT_STATUS_OPTIONS: IncidentStatus[] = Object.values(INCIDENT_STATUS)
    .filter((status) => ![INCIDENT_STATUS.ONGOING.value, INCIDENT_STATUS.ACKNOWLEDGED.value].includes(status.value))
    .map((status) => ({
        value: status.value,
        title: status.label,
        color: status.color,
        textColor: status.textColor
    }));

const SEVERITIES_OPTIONS = Object.values(SEVERITIES_INFO)
    .filter((severityItem) => severityItem.value !== SEVERITIES_INFO[RISK_SEVERITY.SECURE].value)
    .map((severity) => ({
        value: severity.value,
        title: severity.label
    }));

const INCIDENT_TYPE_OPTIONS = Object.values(INCIDENT_TYPE).map((type) => ({
    value: type.value,
    title: type.guiName
}));

export { SEVERITIES_OPTIONS, INCIDENT_STATUS_OPTIONS, INCIDENT_TYPE_OPTIONS };
